import dictItemSelect from './DictItemSelect.vue'
const DictItemSelect = {
	install: function(Vue) {
		Vue.component('DictItemSelect', dictItemSelect)
	}
}
export default DictItemSelect